var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTcfd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "79.375mm",
    height: "12.042574mm",
    viewBox: "0 0 79.375 12.042574",
    id: "svg3344",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs3341"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath2817"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 419.824,92.236 c -0.658,0 -1.437,-0.364 -1.437,-1.22 v 0 c 0,-0.812 0.614,-1.071 1.209,-1.254 v 0 c 0.569,-0.175 1.095,-0.333 1.095,-0.955 v 0 c 0,-0.574 -0.532,-0.864 -0.994,-0.864 v 0 c -0.468,0 -0.829,0.246 -1.025,0.561 v 0 l -0.393,-0.29 c 0.324,-0.441 0.868,-0.661 1.412,-0.661 v 0 c 0.708,0 1.468,0.39 1.468,1.285 v 0 c 0,0.894 -0.702,1.095 -1.335,1.302 v 0 c -0.501,0.164 -0.975,0.309 -0.975,0.876 v 0 c 0,0.573 0.512,0.837 0.956,0.837 v 0 c 0.423,0 0.733,-0.176 0.923,-0.447 v 0 l 0.361,0.29 c -0.215,0.289 -0.664,0.54 -1.265,0.54 z",
    id: "path2815"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath2835"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 433.539,92.236 c -1.3,-0.033 -2.266,-1.01 -2.266,-2.34 v 0 c 0,-1.354 1,-2.342 2.334,-2.342 v 0 c 1.335,0 2.335,0.988 2.335,2.342 v 0 c 0,1.33 -0.966,2.307 -2.266,2.34 v 0 z m -1.786,-2.34 c 0,1.038 0.703,1.944 1.854,1.944 v 0 c 1.151,0 1.854,-0.906 1.854,-1.944 v 0 c 0,-1.039 -0.703,-1.94 -1.854,-1.94 v 0 c -1.151,0 -1.854,0.901 -1.854,1.94",
    id: "path2833"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath2845"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 436.892,92.124 v -4.457 h 0.456 v 2.084 h 0.759 l 1.241,-2.084 h 0.556 l -1.31,2.121 c 0.652,0.07 1.146,0.485 1.146,1.146 v 0 c 0,0.869 -0.646,1.19 -1.532,1.19 v 0 z m 0.456,-0.391 h 0.81 c 0.677,0 1.126,-0.214 1.126,-0.799 v 0 c 0,-0.529 -0.418,-0.794 -1.145,-0.794 v 0 h -0.791 z",
    id: "path2843"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath2855"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 442.71,92.236 c -1.301,-0.033 -2.267,-1.011 -2.267,-2.34 v 0 c 0,-1.354 0.981,-2.342 2.335,-2.342 v 0 c 0.803,0 1.379,0.383 1.676,0.831 v 0 l -0.354,0.226 c -0.31,-0.46 -0.804,-0.661 -1.316,-0.661 v 0 c -1.151,0 -1.86,0.906 -1.86,1.946 v 0 c 0,1.038 0.702,1.944 1.86,1.944 v 0 c 0.569,0 1.019,-0.296 1.208,-0.584 v 0 l 0.38,0.276 c -0.3,0.42 -0.896,0.687 -1.529,0.704 v 0 z",
    id: "path2853"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath2869"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 450.528,88.958 c 0,-0.784 0.579,-1.356 1.353,-1.356 v 0 c 0.772,0 1.351,0.572 1.351,1.356 v 0 c 0,0.784 -0.579,1.356 -1.351,1.356 v 0 c -0.774,0 -1.353,-0.572 -1.353,-1.356 m 0.278,0 c 0,0.601 0.407,1.127 1.075,1.127 v 0 c 0.666,0 1.073,-0.526 1.073,-1.127 v 0 c 0,-0.602 -0.407,-1.123 -1.073,-1.123 v 0 c -0.668,0 -1.075,0.521 -1.075,1.123",
    id: "path2867"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath2883"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 410.66,83.597 c 0,-1.353 0.981,-2.341 2.335,-2.341 v 0 c 0.802,0 1.379,0.383 1.676,0.83 v 0 l -0.354,0.227 c -0.311,-0.46 -0.804,-0.661 -1.317,-0.661 v 0 c -1.151,0 -1.859,0.906 -1.859,1.945 v 0 c 0,1.039 0.702,1.945 1.859,1.945 v 0 c 0.57,0 1.019,-0.295 1.209,-0.585 v 0 l 0.38,0.277 c -0.311,0.434 -0.936,0.705 -1.594,0.705 v 0 c -1.336,0 -2.335,-0.988 -2.335,-2.342",
    id: "path2881"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath2917"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 441.203,85.826 v -4.457 h 0.456 v 2.083 h 0.758 l 1.241,-2.083 h 0.557 l -1.311,2.121 c 0.652,0.07 1.146,0.485 1.146,1.146 v 0 c 0,0.869 -0.645,1.19 -1.532,1.19 v 0 z m 0.456,-0.39 h 0.81 c 0.677,0 1.125,-0.214 1.125,-0.8 v 0 c 0,-0.528 -0.418,-0.793 -1.144,-0.793 v 0 h -0.791 z",
    id: "path2915"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath2947"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 463.373,85.826 v -4.457 h 1.487 c 1.119,0 2.352,0.742 2.352,2.228 v 0 c 0,1.486 -1.233,2.229 -2.352,2.229 v 0 z m 0.455,-0.403 h 0.905 c 1.348,0 1.999,-0.907 1.999,-1.826 v 0 c 0,-0.919 -0.651,-1.826 -1.999,-1.826 v 0 h -0.905 z",
    id: "path2945"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath2975"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 429.962,77.299 c 0,-1.353 0.982,-2.342 2.336,-2.342 v 0 c 0.803,0 1.379,0.385 1.676,0.831 v 0 l -0.355,0.227 c -0.309,-0.46 -0.803,-0.661 -1.316,-0.661 v 0 c -1.151,0 -1.859,0.907 -1.859,1.945 v 0 c 0,1.039 0.702,1.946 1.859,1.946 v 0 c 0.57,0 1.02,-0.296 1.209,-0.586 v 0 l 0.38,0.277 c -0.311,0.434 -0.936,0.705 -1.594,0.705 v 0 c -1.336,0 -2.336,-0.988 -2.336,-2.342",
    id: "path2973"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath2995"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 410.9,73.23 v -4.457 h 1.487 c 1.12,0 2.354,0.743 2.354,2.228 v 0 c 0,1.486 -1.234,2.229 -2.354,2.229 v 0 z m 0.456,-0.403 h 0.905 c 1.347,0 1.998,-0.906 1.998,-1.826 v 0 c 0,-0.919 -0.651,-1.825 -1.998,-1.825 v 0 h -0.905 z",
    id: "path2993"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3007"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 417.166,72.122 c 0,-0.811 0.614,-1.071 1.208,-1.253 v 0 c 0.57,-0.176 1.094,-0.333 1.094,-0.956 v 0 c 0,-0.573 -0.531,-0.863 -0.992,-0.863 v 0 c -0.468,0 -0.829,0.246 -1.025,0.561 v 0 l -0.393,-0.29 c 0.322,-0.441 0.868,-0.662 1.411,-0.662 v 0 c 0.709,0 1.468,0.391 1.468,1.285 v 0 c 0,0.894 -0.702,1.095 -1.335,1.303 v 0 c -0.5,0.164 -0.974,0.308 -0.974,0.875 v 0 c 0,0.573 0.512,0.837 0.956,0.837 v 0 c 0.423,0 0.733,-0.176 0.923,-0.447 v 0 l 0.36,0.29 c -0.215,0.29 -0.663,0.541 -1.265,0.541 v 0 c -0.657,0 -1.436,-0.365 -1.436,-1.221",
    id: "path3005"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3017"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 420.666,71.002 c 0,-1.354 0.98,-2.342 2.335,-2.342 v 0 c 0.803,0 1.379,0.384 1.676,0.831 v 0 l -0.354,0.227 c -0.311,-0.46 -0.804,-0.662 -1.317,-0.662 v 0 c -1.151,0 -1.859,0.906 -1.859,1.946 v 0 c 0,1.038 0.702,1.945 1.859,1.945 v 0 c 0.57,0 1.019,-0.296 1.209,-0.585 v 0 l 0.38,0.276 c -0.311,0.435 -0.936,0.706 -1.594,0.706 v 0 c -1.336,0 -2.335,-0.989 -2.335,-2.342",
    id: "path3015"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3031"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 428.26,71.002 c 0,-1.354 0.999,-2.342 2.335,-2.342 v 0 c 1.335,0 2.334,0.988 2.334,2.342 v 0 c 0,1.353 -0.999,2.342 -2.334,2.342 v 0 c -1.336,0 -2.335,-0.989 -2.335,-2.342 m 0.481,0 c 0,1.038 0.702,1.945 1.854,1.945 v 0 c 1.151,0 1.853,-0.907 1.853,-1.945 v 0 c 0,-1.039 -0.702,-1.94 -1.853,-1.94 v 0 c -1.152,0 -1.854,0.901 -1.854,1.94",
    id: "path3029"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3041"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 433.71,72.122 c 0,-0.811 0.613,-1.071 1.208,-1.253 v 0 c 0.569,-0.176 1.094,-0.333 1.094,-0.956 v 0 c 0,-0.573 -0.531,-0.863 -0.993,-0.863 v 0 c -0.468,0 -0.828,0.246 -1.025,0.561 v 0 l -0.392,-0.29 c 0.323,-0.441 0.867,-0.662 1.41,-0.662 v 0 c 0.709,0 1.468,0.391 1.468,1.285 v 0 c 0,0.894 -0.702,1.095 -1.334,1.303 v 0 c -0.501,0.164 -0.974,0.308 -0.974,0.875 v 0 c 0,0.573 0.512,0.837 0.955,0.837 v 0 c 0.424,0 0.733,-0.176 0.923,-0.447 v 0 l 0.361,0.29 c -0.215,0.29 -0.664,0.541 -1.265,0.541 v 0 c -0.658,0 -1.436,-0.365 -1.436,-1.221",
    id: "path3039"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3051"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 440.322,73.23 v -2.745 c 0,-0.717 -0.31,-1.423 -1.221,-1.423 v 0 c -0.911,0 -1.22,0.706 -1.22,1.423 v 0 2.745 h -0.456 v -2.795 c 0,-0.743 0.335,-1.775 1.676,-1.775 v 0 c 1.341,0 1.677,1.032 1.677,1.775 v 0 2.795 z",
    id: "path3049"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3061"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 441.943,73.23 v -4.457 h 0.456 v 2.084 h 0.759 l 1.239,-2.084 h 0.559 l -1.311,2.122 c 0.652,0.069 1.145,0.484 1.145,1.145 v 0 c 0,0.869 -0.644,1.19 -1.531,1.19 v 0 z m 0.456,-0.39 h 0.81 c 0.677,0 1.126,-0.214 1.126,-0.8 v 0 c 0,-0.529 -0.418,-0.793 -1.145,-0.793 v 0 h -0.791 z",
    id: "path3059"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3075"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 449.311,72.122 c 0,-0.811 0.612,-1.071 1.207,-1.253 v 0 c 0.57,-0.176 1.095,-0.333 1.095,-0.956 v 0 c 0,-0.573 -0.531,-0.863 -0.994,-0.863 v 0 c -0.468,0 -0.828,0.246 -1.024,0.561 v 0 l -0.392,-0.29 c 0.323,-0.441 0.866,-0.662 1.411,-0.662 v 0 c 0.708,0 1.467,0.391 1.467,1.285 v 0 c 0,0.894 -0.702,1.095 -1.335,1.303 v 0 c -0.499,0.164 -0.974,0.308 -0.974,0.875 v 0 c 0,0.573 0.512,0.837 0.955,0.837 v 0 c 0.424,0 0.734,-0.176 0.924,-0.447 v 0 l 0.361,0.29 c -0.216,0.29 -0.665,0.541 -1.266,0.541 v 0 c -0.658,0 -1.435,-0.365 -1.435,-1.221",
    id: "path3073"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3089"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 336.959,91.333 c -1.461,-0.571 -2.715,-1.371 -3.764,-2.399 v 0 c -1.049,-1.027 -1.865,-2.25 -2.45,-3.667 v 0 c -0.584,-1.418 -0.876,-2.973 -0.876,-4.666 v 0 c 0,-1.661 0.255,-3.199 0.767,-4.618 v 0 c 0.511,-1.417 1.244,-2.642 2.199,-3.675 v 0 c 0.955,-1.033 2.118,-1.843 3.491,-2.429 v 0 c 1.371,-0.587 2.924,-0.88 4.655,-0.88 v 0 c 1.889,0 3.525,0.303 4.908,0.91 v 0 c 1.382,0.608 2.532,1.509 3.451,2.703 v 0 l -2.775,2.808 c -0.067,-0.016 -0.524,-0.444 -0.524,-0.444 v 0 c 0,0 -1.019,-0.711 -1.326,-0.893 v 0 c -0.308,-0.181 -0.632,-0.329 -0.971,-0.443 v 0 c -0.339,-0.115 -0.707,-0.195 -1.103,-0.241 v 0 c -0.397,-0.047 -0.835,-0.071 -1.315,-0.071 v 0 c -0.834,0 -1.617,0.161 -2.348,0.483 v 0 c -0.73,0.322 -1.369,0.792 -1.917,1.409 v 0 c -0.547,0.619 -0.981,1.379 -1.299,2.283 v 0 c -0.319,0.902 -0.478,1.936 -0.478,3.098 v 0 c 0,1.112 0.159,2.114 0.478,3.007 v 0 c 0.318,0.892 0.761,1.653 1.33,2.282 v 0 c 0.569,0.628 1.249,1.11 2.043,1.448 v 0 c 0.792,0.337 1.67,0.506 2.629,0.506 v 0 c 0.554,0 1.036,-0.042 1.448,-0.125 v 0 c 0.412,-0.082 0.772,-0.184 1.08,-0.304 v 0 c 0.308,-0.119 0.574,-0.248 0.799,-0.389 v 0 c 0.224,-0.139 1.917,-1.068 1.917,-1.068 v 0 l 2.614,3.209 c -0.428,0.447 -0.919,0.856 -1.472,1.224 v 0 c -0.553,0.369 -1.159,0.685 -1.816,0.95 v 0 c -0.657,0.265 -1.364,0.473 -2.12,0.623 v 0 c -0.757,0.15 -1.563,0.226 -2.418,0.226 v 0 c -1.764,0 -3.376,-0.286 -4.837,-0.857",
    id: "path3087"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3099"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 373.836,91.94 H 351.75 V 69.248 h 5.321 v 8.831 h 7.795 v 4.065 h -7.795 v 5.747 h 16.765 3.21 c 1.011,0 1.914,-0.169 2.707,-0.506 v 0 c 0.793,-0.338 1.464,-0.82 2.012,-1.449 v 0 c 0.547,-0.628 0.967,-1.394 1.26,-2.297 v 0 c 0.291,-0.903 0.438,-1.915 0.438,-3.038 v 0 c 0,-1.131 -0.147,-2.149 -0.438,-3.052 v 0 c -0.293,-0.903 -0.713,-1.669 -1.26,-2.297 v 0 c -0.548,-0.628 -1.219,-1.112 -2.012,-1.448 v 0 c -0.793,-0.339 -1.696,-0.507 -2.707,-0.507 v 0 h -3.538 v 11.494 h -5.322 V 69.248 h 8.86 c 1.773,0 3.389,0.282 4.843,0.848 v 0 c 1.456,0.566 2.701,1.355 3.733,2.368 v 0 c 1.033,1.012 1.834,2.212 2.403,3.598 v 0 c 0.569,1.386 0.853,2.9 0.853,4.539 v 0 c 0,1.631 -0.284,3.14 -0.853,4.525 v 0 c -0.569,1.386 -1.37,2.584 -2.403,3.591 v 0 c -1.032,1.007 -2.277,1.796 -3.733,2.367 v 0 c -1.454,0.571 -3.07,0.856 -4.843,0.856 v 0 z",
    id: "path3097"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-22.259148,-35.985612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4031",
    transform: "matrix(1.44787,0,0,1.44787,-9.9692032,-16.116873)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2803",
    transform: "matrix(0.35277777,0,0,-0.35277777,57.032699,36.025121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -0.403 h 1.499 v -4.055 h 0.455 v 4.055 H 3.453 V 0 Z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2805"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2807",
    transform: "matrix(0.35277777,0,0,-0.35277777,58.849751,36.025121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -1.936,-4.458 h 0.501 l 0.486,1.171 H 1.366 L 1.859,-4.458 H 2.366 L 0.443,0 Z m 0.208,-0.504 0.987,-2.367 h -1.974 z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2809"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2811",
    transform: "matrix(0.35277777,0,0,-0.35277777,-87.740948,68.52442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2813",
    clipPath: "url(#clipPath2817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 418.153,92.364 h 3.132 v -4.937 h -3.132 z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2819"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2821",
    transform: "matrix(0.35277777,0,0,-0.35277777,62.091426,36.025121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -2.132,-2.003 H -2.138 V 0 h -0.456 v -4.458 h 0.456 v 2.374 h 0.006 L 0.107,-4.458 H 0.778 L -1.607,-2.021 0.652,0 Z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2823"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2825",
    transform: "matrix(0.35277777,0,0,-0.35277777,63.232521,36.025121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -4.458 h 0.455 v 2.11 h 2.088 v 0.396 H 0.455 v 1.549 H 2.702 V 0 Z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2827"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2829",
    transform: "matrix(0.35277777,0,0,-0.35277777,-87.740948,68.52442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2831",
    clipPath: "url(#clipPath2835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 431.146,92.364 h 4.922 v -4.937 h -4.922 z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2837"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2839",
    transform: "matrix(0.35277777,0,0,-0.35277777,-87.740948,68.52442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2841",
    clipPath: "url(#clipPath2845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 436.766,92.251 h 3.265 v -4.71 h -3.265 z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2847"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2849",
    transform: "matrix(0.35277777,0,0,-0.35277777,-87.740948,68.52442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2851",
    clipPath: "url(#clipPath2855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 440.316,92.364 h 4.265 v -4.937 h -4.265 z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2857"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2859",
    transform: "matrix(0.35277777,0,0,-0.35277777,69.330109,36.025121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -4.458 h 2.853 v 0.403 H 0.455 v 1.719 h 2.17 v 0.397 h -2.17 v 1.536 H 2.777 V 0 Z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2861"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2863",
    transform: "matrix(0.35277777,0,0,-0.35277777,-87.740948,68.52442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2865",
    clipPath: "url(#clipPath2869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 450.401,90.441 h 2.958 v -2.967 h -2.958 z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2871"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2873",
    transform: "matrix(0.35277777,0,0,-0.35277777,72.994693,36.686791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -2.199 H -0.007 L -1.517,0 h -0.33 v -2.581 h 0.264 v 2.22 h 0.007 l 1.51,-2.22 h 0.33 V 0 Z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2875"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2877",
    transform: "matrix(0.35277777,0,0,-0.35277777,-87.740948,68.52442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2879",
    clipPath: "url(#clipPath2883)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 410.533,86.066 h 4.264 v -4.937 h -4.264 z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2885"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2887",
    transform: "matrix(0.35277777,0,0,-0.35277777,58.823081,38.246986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -4.457 h 2.543 v 0.402 H 0.455 V 0 Z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2889"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 59.961813,39.819246 h 0.160514 v -1.572331 h -0.160514 z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.352778
    },
    id: "path2891"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2893",
    transform: "matrix(0.35277777,0,0,-0.35277777,61.854571,38.246986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -1.499,-3.689 H -1.507 L -3.024,0 H -3.72 v -4.457 h 0.456 v 3.872 h 0.011 l 1.62,-3.872 h 0.241 l 1.62,3.872 H 0.24 V -4.457 H 0.696 V 0 Z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2895"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2897",
    transform: "matrix(0.35277777,0,0,-0.35277777,63.015669,38.246986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -1.935,-4.457 h 0.5 l 0.486,1.171 H 1.367 L 1.86,-4.457 H 2.366 L 0.443,0 Z m 0.209,-0.504 0.987,-2.367 h -1.974 z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2899"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2901",
    transform: "matrix(0.35277777,0,0,-0.35277777,63.766556,38.246986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -0.403 h 1.499 v -4.054 h 0.455 v 4.054 H 3.453 V 0 Z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2903"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2905",
    transform: "matrix(0.35277777,0,0,-0.35277777,65.221976,38.246986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -4.457 h 2.853 v 0.402 H 0.455 v 1.719 h 2.17 v 0.397 h -2.17 v 1.536 H 2.777 V 0 Z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2907"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 66.534768,39.212821 h 0.959556 v -0.132998 h -0.959556 z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.352778
    },
    id: "path2909"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2911",
    transform: "matrix(0.35277777,0,0,-0.35277777,-87.740948,68.52442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2913",
    clipPath: "url(#clipPath2917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 441.076,85.953 h 3.265 v -4.71 h -3.265 z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2919"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2921",
    transform: "matrix(0.35277777,0,0,-0.35277777,69.243114,38.246986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -4.457 h 2.853 v 0.402 H 0.455 v 1.719 h 2.17 v 0.397 h -2.17 v 1.536 H 2.776 V 0 Z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2923"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2925",
    transform: "matrix(0.35277777,0,0,-0.35277777,70.564866,38.246986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -4.457 h 2.542 v 0.402 H 0.455 V 0 Z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2927"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2929",
    transform: "matrix(0.35277777,0,0,-0.35277777,72.198721,38.246986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -1.935,-4.457 h 0.5 l 0.487,1.171 H 1.367 L 1.86,-4.457 H 2.366 L 0.444,0 Z m 0.209,-0.504 0.987,-2.367 h -1.974 z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2931"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2933",
    transform: "matrix(0.35277777,0,0,-0.35277777,72.949608,38.246986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -0.403 h 1.499 v -4.054 h 0.455 v 4.054 H 3.453 V 0 Z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2935"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2937",
    transform: "matrix(0.35277777,0,0,-0.35277777,74.405028,38.246986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -4.457 h 2.853 v 0.402 H 0.455 v 1.719 h 2.169 v 0.397 H 0.455 v 1.536 H 2.777 V 0 Z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2939"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2941",
    transform: "matrix(0.35277777,0,0,-0.35277777,-87.740948,68.52442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2943",
    clipPath: "url(#clipPath2947)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 463.246,85.953 h 4.093 v -4.71 h -4.093 z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2949"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2951",
    transform: "matrix(0.35277777,0,0,-0.35277777,57.215579,40.468851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -4.457 h 0.455 v 2.109 h 2.088 v 0.397 H 0.455 v 1.549 H 2.701 V 0 Z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2953"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 58.469915,42.04104 h 0.160514 v -1.572683 h -0.160514 z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.352778
    },
    id: "path2955"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2957",
    transform: "matrix(0.35277777,0,0,-0.35277777,60.175314,40.468851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -3.795 H -0.012 L -2.618,0 h -0.569 v -4.457 h 0.455 v 3.834 h 0.012 l 2.607,-3.834 H 0.456 V 0 Z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2959"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2961",
    transform: "matrix(0.35277777,0,0,-0.35277777,61.251956,40.468851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -1.935,-4.457 h 0.499 l 0.487,1.171 H 1.366 L 1.86,-4.457 H 2.366 L 0.443,0 Z M 0.209,-0.503 1.196,-2.87 h -1.975 z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2963"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2965",
    transform: "matrix(0.35277777,0,0,-0.35277777,63.444294,40.468851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -3.795 H -0.014 L -2.62,0 h -0.569 v -4.457 h 0.456 v 3.834 h 0.012 l 2.607,-3.834 H 0.455 V 0 Z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2967"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2969",
    transform: "matrix(0.35277777,0,0,-0.35277777,-87.740948,68.52442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2971",
    clipPath: "url(#clipPath2975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 429.836,79.768 h 4.265 v -4.937 h -4.265 z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2977"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m 65.632715,42.04104 h 0.160514 v -1.572683 h -0.160514 z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.352778
    },
    id: "path2979"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2981",
    transform: "matrix(0.35277777,0,0,-0.35277777,66.708829,40.468851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -1.936,-4.457 h 0.5 l 0.487,1.171 H 1.366 L 1.859,-4.457 H 2.365 L 0.442,0 Z M 0.209,-0.503 1.195,-2.87 h -1.974 z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2983"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2985",
    transform: "matrix(0.35277777,0,0,-0.35277777,67.776264,40.468851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -4.457 h 2.543 v 0.403 H 0.455 V 0 Z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2987"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2989",
    transform: "matrix(0.35277777,0,0,-0.35277777,-87.740948,68.52442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2991",
    clipPath: "url(#clipPath2995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 410.774,73.357 h 4.093 v -4.71 h -4.093 z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2997"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M 58.905596,44.262834 H 59.06611 V 42.690151 H 58.905596 Z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.352778
    },
    id: "path2999"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3001",
    transform: "matrix(0.35277777,0,0,-0.35277777,-87.740948,68.52442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3003",
    clipPath: "url(#clipPath3007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 416.931,73.47 h 3.132 v -4.937 h -3.132 z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path3009"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3011",
    transform: "matrix(0.35277777,0,0,-0.35277777,-87.740948,68.52442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3013",
    clipPath: "url(#clipPath3017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 420.539,73.47 h 4.264 v -4.937 h -4.264 z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path3019"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3021",
    transform: "matrix(0.35277777,0,0,-0.35277777,62.353046,42.690398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -4.458 h 2.543 v 0.403 H 0.455 V 0 Z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path3023"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3025",
    transform: "matrix(0.35277777,0,0,-0.35277777,-87.740948,68.52442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3027",
    clipPath: "url(#clipPath3031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 428.133,73.47 h 4.923 v -4.937 h -4.923 z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path3033"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3035",
    transform: "matrix(0.35277777,0,0,-0.35277777,-87.740948,68.52442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3037",
    clipPath: "url(#clipPath3041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 433.476,73.47 h 3.132 v -4.937 h -3.132 z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path3043"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3045",
    transform: "matrix(0.35277777,0,0,-0.35277777,-87.740948,68.52442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3047",
    clipPath: "url(#clipPath3051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 437.298,73.357 h 3.606 v -4.823 h -3.606 z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path3053"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3055",
    transform: "matrix(0.35277777,0,0,-0.35277777,-87.740948,68.52442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3057",
    clipPath: "url(#clipPath3061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 441.817,73.357 h 3.265 v -4.71 h -3.265 z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path3063"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3065",
    transform: "matrix(0.35277777,0,0,-0.35277777,69.504416,42.690398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -4.458 h 2.852 v 0.403 H 0.455 v 1.72 h 2.17 v 0.396 h -2.17 v 1.536 H 2.776 V 0 Z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path3067"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3069",
    transform: "matrix(0.35277777,0,0,-0.35277777,-87.740948,68.52442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3071",
    clipPath: "url(#clipPath3075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 449.076,73.47 h 3.132 v -4.937 h -3.132 z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path3077"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3079",
    transform: "matrix(0.35277777,0,0,-0.35277777,22.259147,36.089891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -4.174 h 6.413 v -18.519 h 5.29 V -4.174 H 18.12 V 0 Z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path3081"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3083",
    transform: "matrix(0.35277777,0,0,-0.35277777,-87.740948,68.52442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3085",
    clipPath: "url(#clipPath3089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 329.742,92.317 h 20.006 V 68.872 h -20.006 z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path3091"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3093",
    transform: "matrix(0.35277777,0,0,-0.35277777,-87.740948,68.52442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3095",
    clipPath: "url(#clipPath3099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 351.623,92.068 h 37.382 V 69.121 h -37.382 z",
    style: {
      fill: "#35a3d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path3101"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcfd);
export default __webpack_public_path__ + "static/media/TCFD.020ea234f577ae8aec8661187f11cd6f.svg";
export { ForwardRef as ReactComponent };